import Parse from "parse";

import type { _User } from "./_User";

type OD3_Tenant = Parse.Object;

export interface CategoryAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  icon?: string;
  name: string;
  order: number;
  parent?: Category;
  tenant?: OD3_Tenant;
  user?: _User;
}

export class Category extends Parse.Object<CategoryAttributes> {
  static className: string = "OD3_Documentation_Category";

  constructor(data?: Partial<CategoryAttributes>) {
    super("OD3_Documentation_Category", data as CategoryAttributes);
  }

  get icon(): string | undefined {
    return super.get("icon");
  }
  set icon(value: string | undefined) {
    super.set("icon", value);
  }
  get name(): string {
    return super.get("name");
  }
  set name(value: string) {
    super.set("name", value);
  }
  get order(): number {
    return super.get("order");
  }
  set order(value: number) {
    super.set("order", value);
  }
  get parent(): Category | undefined {
    return super.get("parent");
  }
  set parent(value: Category | undefined) {
    super.set("parent", value);
  }
  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
  get user(): _User | undefined {
    return super.get("user");
  }
  set user(value: _User | undefined) {
    super.set("user", value);
  }
}

Parse.Object.registerSubclass("OD3_Documentation_Category", Category);
